/* eslint-disable @typescript-eslint/no-use-before-define */
import { useMemo } from 'react';
import type { KVPairs } from '@types';
import { Divider } from 'react-daisyui';
import {
  filterDeals,
  prettifyKey,
  prettifyValue,
  removePrefixOnObjectProperties,
} from './utils';

// eslint-disable-next-line import/prefer-default-export
export function AccountDataDisplay({
  companyData,
}: {
  companyData: KVPairs | KVPairs[];
}) {
  const prefix = 'company_';
  const filteredData = useMemo(
    () => removePrefixOnObjectProperties(companyData, prefix),
    [companyData]
  );

  return (
    <div
      className='px-8 mb-4 mt-6 max-h-[calc(100vh-300px)] overflow-y-auto'
      data-testid='account-data-display'
    >
      <RowGroup data={filteredData} />
    </div>
  );
}

function RowGroup({
  data,
  bordered,
}: {
  data: KVPairs | KVPairs[];
  bordered?: boolean;
}) {
  return (
    <div className={`${bordered ? 'mb-5' : ''}`}>
      {Array.isArray(data)
        ? data.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <RowGroup key={index} data={item} bordered />
          ))
        : Object.entries(filterDeals(data, ['closedwon', 'churned'])).map(
            ([label, value]: [
              string,
              string | number | undefined | KVPairs[]
            ]) => {
              if (Array.isArray(value)) {
                const reversedDeals = value.slice().reverse();
                return reversedDeals.map((item, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={index}>
                    <Divider />
                    <RowGroup data={item} bordered />
                  </div>
                ));
              }
              if (value) {
                return <Row key={label} label={label} value={value} />;
              }
              return <EmptyRow key={label} label={label} />;
            }
          )}
    </div>
  );
}

function Row({ label, value }: { label: string; value: string | number }) {
  return (
    <div className='my-5 break-all flex'>
      <div className='capitalize w-[38%] text-sm text-right pr-3'>
        {prettifyKey(label)}
      </div>
      <div className='font-bold text-sm w-[58%] text-left pl-3'>
        {prettifyValue(value)}
      </div>
    </div>
  );
}

function EmptyRow({ label }: { label: string }) {
  return (
    <div className='my-5 break-all flex'>
      <div className='capitalize w-[38%] text-sm text-right pr-3'>
        {prettifyKey(label)}
      </div>
      <div className='font-bold w-[58%] text-sm text-left pl-3'>N/A</div>
    </div>
  );
}
